angular
    .module('signalview.detector.notification')

    .service('notifyBlockService', [
        'featureEnabled',
        function (featureEnabled) {
            function getEmailTemplateName(templateId, emailTemplates) {
                let emailTemplateName;

                if (!Array.isArray(emailTemplates)) {
                    return emailTemplateName;
                }

                emailTemplates.some(function (emailTemplate) {
                    if (emailTemplate.id === templateId) {
                        emailTemplateName = emailTemplate.name;
                        return true;
                    }
                    return false;
                });

                return emailTemplateName;
            }

            return function (notification, emailTemplates) {
                switch (notification.type) {
                    case 'pagerduty':
                        return notification.credentialName + ' (PagerDuty)';
                    case 'slack': {
                        return notification.credentialName
                            ? notification.channel + ' (' + notification.credentialName + ')'
                            : notification.channel;
                    }
                    case 'splunkplatform':
                        return notification.credentialName + ' (Splunk Platform)';
                    case 'servicenow':
                        return notification.credentialName + ' (ServiceNow)';
                    case 'email':
                        return notification.email;
                    case 'EmailTemplate':
                    case 'emailtemplate':
                        if (!featureEnabled('emailTemplatesEnabled')) {
                            return '';
                        }
                        if (!notification.templateId) {
                            return 'Email Template';
                        }

                        return `Email Template: ${
                            getEmailTemplateName(notification.templateId, emailTemplates) ||
                            notification.templateId
                        }`;
                    case 'team':
                        return `${notification.teamName || ''} (Team)`;
                    case 'victorops':
                        return notification.credentialName + ' (Splunk On-Call)';
                    case 'webhook':
                        return notification.credentialName
                            ? notification.credentialName + ' (Webhook)'
                            : notification.url;
                    case 'xmatters':
                        return notification.credentialName + ' (xMatters)';
                    case 'bigpanda':
                        return notification.credentialName + ' (BigPanda)';
                    case 'office365':
                        return notification.credentialName + ' (Microsoft Teams)';
                    case 'opsgenie': {
                        const opsGenieMessage = notification.displayName || '(No Team)';
                        return notification.credentialName
                            ? opsGenieMessage + ' (' + notification.credentialName + ')'
                            : opsGenieMessage;
                    }
                    case 'amazoneventbridge':
                        return notification.credentialName + ' (Amazon EventBridge)';
                    case 'jira':
                        return notification.credentialName + ' (Jira)';
                    default:
                        return '';
                }
            };
        },
    ]);
